export default __webpack_public_path__ + "static/media/login.8b13dac5.jpg";